import { Tooltip } from '@mui/material';
import React, { FC } from 'react';

import translate from '../../../../i18n/translate';
import { AttachmentMode } from '../../../../models/attachment';

import Spinner from '../../../Common/Spinner';

import MuiIcon from '../../../MUI/MuiIcon';

import { getButtonColor, getButtonIcon } from './helpers';
import * as Styled from './styled';

const SPINNER_SIZE = 28;

export type Props = {
  isUploading?: boolean;
  mode: AttachmentMode;
  requestButtonClick: () => void;
};

/**
 * Button used for deleting attachment
 *
 * @param props                    Props passed to the component
 * @param props.isUploading        Whether the attachment is being uploaded
 * @param props.mode               In which mode to render the component
 * @param props.requestButtonClick Callback for delete button click
 * @returns                        The component itself
 */
const ButtonAttachmentDelete: FC<Props> = ({
  isUploading = false,
  mode,
  requestButtonClick,
}) => {
  const color = getButtonColor(mode);
  const icon = getButtonIcon(mode);

  if (mode !== 'compose' && mode !== 'detailsEdit') {
    return null;
  }

  if (isUploading) {
    return <Spinner size={SPINNER_SIZE} />;
  }

  return (
    <Tooltip placement="top" title={translate('GENERAL__REMOVE')}>
      <Styled.ButtonDelete
        color={color}
        disableFocusRipple={true}
        onClick={requestButtonClick}
        variant={mode === 'compose' ? 'contained' : undefined}
      >
        <MuiIcon fontSize="small" icon={icon} />
      </Styled.ButtonDelete>
    </Tooltip>
  );
};

export default ButtonAttachmentDelete;
